interface Props {
  label?: string;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  inputClassName?: string;
  labelClassName?: string;
  options?: { value: string; label: string; disabled?: boolean }[];
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
}

export const FormSelect = ({
  label,
  value,
  onChange,
  inputClassName,
  labelClassName,
  options,
  placeholder,
  disabled,
  error,
  ...rest
}: Props) => {
  return (
    <div className="mb-4">
      <p
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </p>
      <select
        disabled={disabled}
        {...rest}
        value={value}
        onChange={onChange}
        className={`w-full h-[46px] px-4 bg-sky-lighter border ${
          error ? "border-red-base" : "border-gray-border"
        } ${
          error ? "focus:border-red-base" : "focus:border-focused-border"
        } rounded font-satoshi text-base text-dark font-medium outline-none ${inputClassName}`}
      >
        {placeholder ? (
          <option value="" disabled selected hidden>
            {placeholder}
          </option>
        ) : null}
        {options?.length
          ? options?.map((option) => (
              <option
                key={option?.value}
                value={option?.value}
                disabled={option?.disabled}
              >
                {option?.label}
              </option>
            ))
          : null}
      </select>
    </div>
  );
};
